import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import Button from '@sorare/core/src/atoms/buttons/Button';
import { Vertical } from '@sorare/core/src/atoms/layout/flex';
import { BodyL, DisplayS } from '@sorare/core/src/atoms/typography';
import { Chip } from '@sorare/core/src/atoms/ui/Chip';
import { Img } from '@sorare/core/src/atoms/ui/Img';
import { useConnectionContext } from '@sorare/core/src/contexts/connection';
import { tabletAndAbove } from '@sorare/core/src/style/mediaQuery';

import { RigidSquareTitle } from 'components/landing/ui/RigidSquareTitle';

import calendarAvif from './assets/calendar.avif';
import calendar from './assets/calendar.jpg';
import cardsAvif from './assets/cards.avif';
import cards from './assets/cards.jpg';
import enterAvif from './assets/enter.avif';
import enter from './assets/enter.jpg';

const Pictures = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--double-unit);
  align-items: center;
  padding: var(--double-unit);
  @media ${tabletAndAbove} {
    flex-direction: row;
    justify-content: space-between;
  }
`;

const Image = styled(Img)`
  border-radius: 20px;
`;
const Block = styled.div`
  position: relative;
`;
const BlockContent = styled.div`
  position: absolute;
  bottom: 0;
  width: 100%;
  padding: var(--double-unit);
`;
export const Howto = () => {
  const { signUp } = useConnectionContext();
  return (
    <Vertical gap={8} center>
      <Vertical center>
        <Chip
          color="black"
          outlined
          label={
            <FormattedMessage
              id="kylianmbappe.Howto.chip"
              defaultMessage="Simple rules"
            />
          }
          size="smaller"
          uppercased
        />
        <RigidSquareTitle>
          <FormattedMessage
            id="kylianmbappe.Howto.title"
            defaultMessage="How to{br}participate?"
            values={{ br: <br /> }}
          />
        </RigidSquareTitle>
      </Vertical>

      <Pictures>
        <Block>
          <picture>
            <source srcSet={enterAvif} type="image/avif" />
            <Image
              src={enter}
              alt=""
              width="368"
              height="532"
              fetchpriority="low"
            />
          </picture>
          <BlockContent className="text-center">
            <DisplayS>
              <FormattedMessage
                id="kylianmbappe.Howto.enter.title"
                defaultMessage="Enter the Kylian Mbappé FC competition"
              />
            </DisplayS>
            <BodyL>
              <FormattedMessage
                id="kylianmbappe.Howto.enter.description"
                defaultMessage="From September 10th to 20th"
              />
            </BodyL>
          </BlockContent>
        </Block>
        <Block>
          <picture>
            <source srcSet={cardsAvif} type="image/avif" />
            <Image
              src={cards}
              alt=""
              width="368"
              height="532"
              fetchpriority="low"
            />
          </picture>
          <BlockContent className="text-center">
            <DisplayS>
              <FormattedMessage
                id="kylianmbappe.Howto.cards.title"
                defaultMessage="Hit 400 points with your team"
              />
            </DisplayS>
            <BodyL>
              <FormattedMessage
                id="kylianmbappe.Howto.cards.description"
                defaultMessage="For a chance to be selected"
              />
            </BodyL>
          </BlockContent>
        </Block>
        <Block>
          <picture>
            <source srcSet={calendarAvif} type="image/avif" />
            <Image
              src={calendar}
              alt=""
              width="368"
              height="532"
              fetchpriority="low"
            />
          </picture>
          <BlockContent className="text-center">
            <DisplayS>
              <FormattedMessage
                id="kylianmbappe.Howto.calendar.title"
                defaultMessage="Three chances to enter and win"
              />
            </DisplayS>
            <BodyL>
              <FormattedMessage
                id="kylianmbappe.Howto.calendar.description"
                defaultMessage="Enter your lineups beforehand"
              />
            </BodyL>
          </BlockContent>
        </Block>
      </Pictures>
      <Button size="large" color="secondary" onClick={signUp}>
        <FormattedMessage
          id="kylianmbappe.Howto.cta"
          defaultMessage="Enter the competition"
        />
      </Button>
    </Vertical>
  );
};
